import React from 'react'
import { Empty } from 'antd'

interface Props {
  style?: Object
  url: string
}

const HotelImageUrl = ({ url, style = {} }: Props) => {
  if (
    ['png', 'jpg', 'jpeg'].includes(
      url
        .split('.')
        .slice(-1)[0]
        .toLowerCase()
    )
  ) {
    return <img alt="logo" src={url} style={style} />
  }
  return <>{Empty.PRESENTED_IMAGE_SIMPLE}</>
}

export { HotelImageUrl }
